import { render } from "./App.vue?vue&type=template&id=d05d688c"
const script = {}

import exportComponent from "/home/jenkins/agent/workspace/build_logistics-fe-ntp-hz_cb461e37a40e4d4db048201803700c7a/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__